import { createService } from '@betty/toolkit/api';
import { BannersResponseSchema } from './BannersService.schemas';

export default {
  ...createService(
    {
      getBanners: {
        method: 'GET',
        url: '/banners',
        responseSchema: BannersResponseSchema,
      },
    },
    ({ userId }) => `/Players/${userId}`,
  ),
  ...createService({
    getPublicBanners: {
      method: 'GET',
      url: '/Lobby/banners',
      public: true,
      responseSchema: BannersResponseSchema,
    },
  }),
};
